import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FormBuilder } from '@tf/formbuilder'

import {
	BoxInfo,
	CircleSpinner,
	getErrorWithFullMessage,
	getLanguageLocale,
	getMarket,
} from 'shared/index'
import SspContext from 'selfServicePortal/contexts/SspContext'
import { Heading } from '../../../../components/index'
import updateCustomerService from '../../../../services/CustomerServices/updateCustomerService'
import {
	ICustomer,
	IUpdateCustomer,
} from 'selfServicePortal/interfaces/i-api-customer'
import './MyAccountNo.scss'
import { FormWrapper } from 'shared/formBuilder/formWrapper'
import { CustomerInformationForm } from 'shared/formBuilder/forms/customerInformationForm'

interface ISubmitCustomerInformation {
	customer: ICustomer
	formMeta: any
}

const MyAccountNo = () => {
	const { t } = useTranslation()
	const { customerData } = useContext(SspContext)
	const [error, setError] = useState<Error>()
	const [success, setSuccess] = useState(false)
	const [loading, setLoading] = useState(false)
	const [customerInformation, setCustomerInformation] = useState<
		IUpdateCustomer | undefined
	>(undefined)

	const formSchema = FormWrapper(
		[CustomerInformationForm(customerData as any)],
		{
			formName: 'Contact',
			blockName: 'Contact',
			market: getMarket(),
			locale: getLanguageLocale(),
			getDataUrl: '',
			validationErrorList: false,
			requiredMessage: t('ValidateRequired'),
			submitButtonText: t('Save'),
		},
	)

	const submit = (customer: ICustomer) => {
		setLoading(true)
		if (customerData) {
			setCustomerInformation({
				...customer,
				customerId: customerData.customerId,
				bankId: customerData.bankId,
				mobilePhoneNumber:
					customer.mobilePhoneNumber ??
					customerData.mobilePhoneNumber,
				email: customer.email ?? customerData.email,
				shortAddress: `${customer.street + ' ' + customer.houseNumber}`,
			})
		} else {
			setCustomerInformation({
				...customer,
			})
		}
	}

	useEffect(() => {
		const updateCustomerInformation = async (
			customerInfo: IUpdateCustomer,
		) => {
			try {
				await updateCustomerService(customerInfo, t)
				setSuccess(true)
				setLoading(false)
			} catch (e: any) {
				setLoading(false)
				setSuccess(false)
				setError(getErrorWithFullMessage(e))
			}
		}

		if (customerInformation) {
			updateCustomerInformation(customerInformation!)
		}
		return () => {}
	}, [customerInformation, t])

	return (
		<div className="fade-in my-account-no container d-flex justify-content-center py-5">
			<div className="fixed-width">
				<Heading title="MyAccountHeading" />
				{loading && <CircleSpinner />}
				{success && !loading && (
					<BoxInfo css={'success'} message={t('MyAccountSuccess')} />
				)}
				{!loading && (
					<FormBuilder
						formSchema={formSchema!}
						apiError={undefined}
						showErrorsInForm={true}
						showSubmitButton={true}
						onSubmit={(values: ISubmitCustomerInformation) =>
							submit(values.customer)
						}
					/>
				)}
				{error && !loading && !success && (
					<div className="error-msg">{error.message}</div>
				)}
			</div>
		</div>
	)
}
export default MyAccountNo
